import * as React from 'react';
import { Icon } from '@grandvisionhq/icons';
import { Text } from '@grandvisionhq/iris-ui';

const ProductDetailUspItem = ({ item  })=>{
    const { icon , text  } = item;
    return /*#__PURE__*/ React.createElement("li", {
        className: "product-detail-usps__item"
    }, icon && /*#__PURE__*/ React.createElement("span", {
        className: "product-detail-usps__icon"
    }, /*#__PURE__*/ React.createElement(Icon, {
        name: icon,
        width: 24,
        height: 24
    })), /*#__PURE__*/ React.createElement(Text, {
        variant: "caption",
        component: "span",
        className: "product-detail-usps__message"
    }, text));
};

export { ProductDetailUspItem };
//# sourceMappingURL=ProductDetailUspItem.js.map
